import {BaseFormModel} from './base-form-model';

export class LimitedAvailability extends BaseFormModel<LimitedAvailability> {
    id: number;
    remaining: number;
    currentUsed = 0;
}
